import { Locale } from 'common/enums/Locale';

const LOCALE_WITH_QR_CODE = [Locale.De_De_H24, Locale.De_At, Locale.De_Ch, Locale.Fr_Ch];

export const isLocaleWithHomeClubQRCode = (locale: Locale) => LOCALE_WITH_QR_CODE.includes(locale);
